
import React, { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import { Button, Badge } from 'reactstrap';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Jamis extends Component{

    constructor(props){
        super(props);
        this.state = {
            APIName: "jamis",
            APIUser: "",
            APIPass: "",
            CompanyCode: "",
            ServiceAddress: "",
            loadingJamis: false,
            type: 'password',
            isAutenticated: true

        };
        this.handleApiUser = this.handleApiUser.bind(this);
        this.handleApiPass = this.handleApiPass.bind(this);
        this.handleCompanyCode = this.handleCompanyCode.bind(this);
        this.handleServiceAddress = this.handleServiceAddress.bind(this);
        this.showHide = this.showHide.bind(this);
    }  

    showHide(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          type: this.state.type === 'input' ? 'password' : 'input'
        })  
      }

    componentDidMount(){

        var JamismList = this.props.DataJamis;

        var jamis = JamismList.find(x=> x.ALIAS === this.state.APIName);  
        var jamisValue = JSON.parse(jamis.VALUE);
        var UserName = jamisValue.UserName === null || jamisValue.UserName === undefined   ? "" :  jamisValue.UserName;
        var Pass = jamisValue.Password === null || jamisValue.Password === undefined   ? "" :  jamisValue.Password;
        var JamisCompanyCode = jamisValue.Company === null || jamisValue.Company === undefined   ? "" :  jamisValue.Company;
        var JamisServiceAddress = jamisValue.ServiceAddress === null || jamisValue.ServiceAddress === undefined   ? "" :  jamisValue.ServiceAddress;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = UserName;
        stateCopy.APIPass = Pass;
        stateCopy.CompanyCode = JamisCompanyCode;
        stateCopy.ServiceAddress = JamisServiceAddress;
        this.setState(stateCopy);
    }

    handleApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = value;
        this.setState(stateCopy);    
    }
    handleApiPass(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIPass = value;
        this.setState(stateCopy);    
    }
    handleCompanyCode(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.CompanyCode = value;
        this.setState(stateCopy);    
    }
    handleServiceAddress(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ServiceAddress = value;
        this.setState(stateCopy);    
    }

    ValidateSaveGeoTab(){

        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var Company = this.state.CompanyCode;
        var ServiceAddress = this.state.ServiceAddress;

        if(UserName === null || UserName === "" || UserName === undefined)
        {
            toast.error("Client API User field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Pass === null || Pass === "" || Pass === undefined)
        {
            toast.error("Client API Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Company === null || Company === "" || Company === undefined)
        {
            toast.error("Company Code field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(ServiceAddress === null || ServiceAddress === "" || ServiceAddress === undefined)
        {
            toast.error("Service Address field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        return true;

    }

    SaveJamis(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var Company = this.state.CompanyCode;
        var ServiceAddress = this.state.ServiceAddress;
        var CompanyCode = this.props.CompanyCode;
        var EasyApiUser = null;
        var EasyApiPassword = null;

        var JamisList = this.props.DataJamis;
        var jamis = JamisList.find(x=> x.ALIAS === this.state.APIName);   

        var Validate = this.ValidateSaveGeoTab();
        if(Validate === false)
        {
            return false;
        }        
        this.setState({
            loadingJamis: true
        });
        var result = APIService.SaveJamisSetting(CompanyCode, Company, ServiceAddress, email, UserName, Pass, EasyApiUser, EasyApiPassword);
        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingJamis: false
                });
                var newList = {
                    ALIAS: jamis.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    ID: jamis.ID,
                    NAME: jamis.NAME,
                    VALUE: {
                        UserName: UserName,
                        Password: Pass,
                        Company: Company,
                        ServiceAddress: ServiceAddress,
                        Name:jamis.ALIAS
                    }
                };
                that.props.SetObject(newList);

                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingJamis: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingJamis: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {

            that.setState({
                loadingJamis: false,
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }   
    render(){      

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2">
                                    <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API User(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="clientapiuser" id="clientapiuser" type="text" onChange={this.handleApiUser}  value={ this.state.APIUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="clientapipass" id="clientapipass" type={this.state.type} onChange={this.handleApiPass }   value={ this.state.APIPass}/>
                            </div>  
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                        
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Company Code(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="companycode" id="companycode" type="text" onChange={this.handleCompanyCode } value={ this.state.CompanyCode}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Service Address(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="ServiceAddress" id="ServiceAddress" type="text" onChange={this.handleServiceAddress }  value={ this.state.ServiceAddress}/>
                            </div>                          
                       </div>
                       <div className="row">             
                            <div className="col-2 offset-10" style={{ 'paddingTop': '280px'}} size="sm">
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingJamis}
                                />
                                {
                                    this.state.loadingJamis
                                    ?
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveJamis(e)} disabled>Save</Button>
                                    : 
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveJamis(e)}>Save</Button>
                                }
                               
                            </div>                             
                       </div>
                   </div>
                </div>
            </div>            
        );
    }
}

export default Jamis;


// WEBPACK FOOTER //
// ./src/APIComponent/Jamis.jsx